
import BaseDynamicComponent from "@/app/dynamic-components/forms/form-components/form-component.base";
import { Component } from "vue-property-decorator";
import DynamicComponentConfigManager from "@/app/components/configmanager/dynamic-component-config-manager.vue";

export type SliderMetaData = {
  disabled?: boolean;
  color?: string;
  trackColor?: string;
  thumbColor?: string;
  thumbLabel?: string | boolean;
  step?: number;
  ticks?: string | boolean;
  tickLabels?: string[];
  min?: number;
  max?: number;
  vertical?: boolean;
  inverseLabel?: boolean;
};

@Component({
  components: {DynamicComponentConfigManager}
})
export default class SliderBase extends BaseDynamicComponent<SliderMetaData> {
  onSliderValueChanged(newValue: boolean): void {
    this.setValueView(newValue);
  }

  public getDefaultValue(): any {
    return this.entry.metadata.min || 0;
  }
}
